import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Menu, LogOut } from 'lucide-react';
import { Button } from '../ui/button';
import { ContextualHelp } from '../ContextualHelp';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from '../ui/dropdown-menu';

const roleLabels = {
  superadmin: 'SuperAdmin',
  pastor: 'Pastor',
  lider: 'Líder',
  voluntario: 'Voluntario',
  authenticated: 'Miembro',
};

export function TopBar({ title, onMenuClick, actionButton, churchInfo }) {
  const { user, logout, roleType } = useAuth();

  return (
    <header className="sticky top-0 z-30 bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b px-4 sm:px-6 lg:px-8 py-3" data-testid="topbar">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-lg hover:bg-accent"
            data-testid="mobile-menu-button"
          >
            <Menu className="w-5 h-5" />
          </button>

          {/* Church logo + name */}
          {churchInfo && (churchInfo.logoUrl || churchInfo.name) ? (
            <div className="flex items-center gap-2.5">
              {churchInfo.logoUrl && (
                <img
                  src={churchInfo.logoUrl}
                  alt={churchInfo.name || 'Iglesia'}
                  className="h-8 w-8 rounded-lg object-cover border border-border/50"
                />
              )}
              <div className="hidden sm:block">
                <p className="text-sm font-semibold text-foreground leading-tight">{churchInfo.name}</p>
                <p className="text-[10px] text-muted-foreground leading-tight">{title}</p>
              </div>
              <h1 className="sm:hidden text-lg font-semibold text-foreground leading-[1.1]">{title}</h1>
            </div>
          ) : (
            <h1 className="text-lg md:text-xl font-semibold text-foreground leading-[1.1]">{title}</h1>
          )}
        </div>
        <div className="flex items-center gap-2">
          {actionButton}
          <ContextualHelp />
          {/* User menu with logout */}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button className="flex items-center gap-2 p-1.5 rounded-lg hover:bg-accent" data-testid="user-menu-button">
                <div className="w-8 h-8 rounded-full bg-[#00CCFF]/20 flex items-center justify-center text-sm font-semibold text-[#056A84]">
                  {(user?.firstname || user?.name || 'U')[0]}
                </div>
                <span className="hidden sm:block text-sm font-medium text-foreground">
                  {user?.firstname || user?.name || 'Usuario'}
                </span>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
              <div className="px-3 py-2">
                <p className="text-sm font-medium">{user?.firstname || ''} {user?.lastname || ''}</p>
                <p className="text-xs text-muted-foreground">{roleLabels[roleType] || roleType}</p>
              </div>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={logout} className="text-destructive focus:text-destructive cursor-pointer" data-testid="logout-button">
                <LogOut className="w-4 h-4 mr-2" />
                Cerrar sesión
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}

export default TopBar;
